import i18n from '~/i18n';
import { globalMessage } from '~/services/message';

let shown = false;

export const showWrongVersionMessage = () => {
    if (shown) return;
    shown = true;

    const timeout = setTimeout(() => {
        window.location.href = window.location.origin + window.location.pathname + '?timestamp=' + new Date().getTime();
    }, 3000);

    globalMessage.error(i18n.errorCodes.WRONG_VERSION, {
        label: i18n.cancel,
        callback: () => {
            clearTimeout(timeout);
            shown = false;
        },
    });
};
